<div class="protectorInformation" [ngClass]="protectionStatus">
    <vn-icon name="sports-protektor-i" size="12" />

    @if (betslip.betProtectorInformation.state === protectorLostState) {
        {{ sitecoreMyBets.myBets.REFUNDED }}
    } @else {
        <span>{{ betslip.betProtectorInformation.numberOfInsuredBets }} </span>
        <span>
            {{ betslip.betProtectorInformation.numberOfInsuredBets > 1 ? sitecoreMyBets.myBets.InsuredPicks : sitecoreMyBets.myBets.InsuredPick }}
        </span>
        <span>{{ isActive ? sitecoreMyBets.myBets.InsuranceActive : '' }} </span>
        <span>({{ betslip.betProtectorInformation.fee }} {{ betslip.payoutAmount.currency }})</span>
    }
</div>
